var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircle = function SvgArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 20c-4.369 0-8-3.631-8-8 0-4.376 3.624-8 7.992-8C12.37 4 16 7.624 16 12c0 4.369-3.623 8-8 8m.008-3.953c.36 0 .612-.25.612-.612v-4.023l-.071-1.726.824.98.949.965c.11.118.258.18.43.18a.584.584 0 0 0 .597-.588.58.58 0 0 0-.172-.423l-2.69-2.69c-.158-.157-.299-.228-.48-.228-.172 0-.305.063-.47.228L4.84 10.8a.57.57 0 0 0-.157.423c0 .33.251.589.589.589.164 0 .321-.07.431-.18l.957-.965.808-.973-.07 1.718v4.023c0 .361.258.612.61.612"
  })));
};
export default SvgArrowCircle;